<template>
    <div class="app-container">
        <el-skeleton v-if="pageLoading" :rows="12" animated />
        <div v-else class="form-box">
            <el-form label-position="right" ref="form" :rules="rules" :model="form" label-width="500px"  >

                <el-form-item label="绘画教学视频" prop="drawTutorialVideo">
                    <UploadVideo
                        v-model="form.drawTutorialVideo"
                        width="250px"
                        height="250px"
                    ></UploadVideo>
                </el-form-item>
                
                <el-form-item label="播放视频">

                    <video width="400" height="300px" controls :src="form.drawTutorialVideo" type="video/mp4"></video>

                </el-form-item>
                
                <p>消耗能量设置</p>

                <el-form-item label="英语对话" prop="englishChatEnergy">
                    <el-input v-model="form.englishChatEnergy" placeholder="请输入次数"></el-input>
                </el-form-item>

                <el-form-item label="英语对话提示" prop="englishChatEnergyPrompt">
                    <el-input v-model="form.englishChatEnergyPrompt" placeholder="请输入次数"></el-input>
                </el-form-item>

                <el-form-item label="英语对话换个话题" prop="englishChatEnergyReplace">
                    <el-input v-model="form.englishChatEnergyReplace" placeholder="请输入次数"></el-input>
                </el-form-item>

                <el-form-item label="英语报告" prop="englishReportEnergy">
                    <el-input v-model="form.englishReportEnergy" placeholder="请输入次数"></el-input>
                </el-form-item>

                <br>
                <br>
                <br>

                <p>限制设置</p>

                <el-form-item label="英语对话" prop="englishChatLimit">
                    <el-input v-model="form.englishChatLimit" placeholder="请输入秒数"></el-input>
                </el-form-item>

                 <el-form-item label="英语对话提示" prop="englishChatLimitPrompt">
                    <el-input v-model="form.englishChatLimitPrompt" placeholder="请输入秒数"></el-input>
                </el-form-item>

                <el-form-item label="英语对话换个话题" prop="englishChatLimitReplace">
                    <el-input v-model="form.englishChatLimitReplace" placeholder="请输入秒数"></el-input>
                </el-form-item>

               

                <el-form-item label="识别语音" prop="englishChatLimitRecording">
                    <el-input v-model="form.englishChatLimitRecording" placeholder="请输入秒数"></el-input>
                </el-form-item>

                <el-form-item label="合成语音" prop="englishChatLimitVoice">
                    <el-input v-model="form.englishChatLimitVoice" placeholder="请输入秒数"></el-input>
                </el-form-item>

                <br>
                <br>
                <br>

                <el-form-item label="注册赠送英语对话次数" prop="registerEnglishChat">
                    <el-input v-model="form.registerEnglishChat" placeholder="请输入次数"></el-input>
                </el-form-item>

                <el-form-item label="注册赠送中文阅读次数" prop="registerEnglishChat">
                    <el-input v-model="form.registerChineseChat" placeholder="请输入次数"></el-input>
                </el-form-item>

                <br>
                <br>
                <br>

                <el-form-item label="英语视频对话积分奖励次数限制(需完成几次,0为关闭)" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishChatVideoLimit" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="英语对话积分奖励次数限制(需完成几次,0为关闭)" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishChatLimit" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="英语跟读积分奖励次数限制(需完成几次,0为关闭)" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishEvaluatingLimit" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="中文阅读积分奖励次数限制(需完成几次,0为关闭)" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralChineseTextLimit" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="英语视频对话积分奖励" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishChatVideo" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="英语对话积分奖励" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishChat" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="英语跟读积分奖励" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralEnglishEvaluating" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="中文阅读积分奖励" prop="registerEnglishChat">
                    <el-input v-model="form.rewardIntegralChineseText" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="saving" @click="handleSubmit('form')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request"
import UploadVideo from "@/components/UploadVideo/index.vue";


export default {
    components: {
        UploadVideo,
    },
    data: () => ({
        rules: {
            englishChatEnergy: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            englishChatEnergyPrompt: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            englishChatEnergyReplace: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            englishReportEnergy: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],

            englishChatLimit: [
                { required: true, message: '请输入秒数', trigger: 'blur' }
            ],
            englishChatLimitPrompt: [
                { required: true, message: '请输入秒数', trigger: 'blur' }
            ],
            englishChatLimitReplace: [
                { required: true, message: '请输入秒数', trigger: 'blur' }
            ],
            englishChatLimitRecording: [
                { required: true, message: '请输入秒数', trigger: 'blur' }
            ],
            englishChatLimitVoice: [
                { required: true, message: '请输入秒数', trigger: 'blur' }
            ],
            registerEnglishChat: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            registerChineseChat: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            drawTutorialVideo: [
                { required: true, message: '请上传视频', trigger: 'blur' }
            ],
        },
        form: {
            englishChatEnergy :'',
            englishChatEnergyPrompt :'',
            englishChatEnergyReplace :'',
            englishReportEnergy :'',
            englishChatLimit :'',
            englishChatLimitPrompt :'',
            englishChatLimitReplace :'',
            englishChatLimitRecording :'',
            englishChatLimitVoice :'',
            registerChineseChat :'',
            registerEnglishChat :'',
            rewardIntegralEnglishChatVideoLimit:'',
            rewardIntegralEnglishChatLimit:'',
            rewardIntegralEnglishEvaluatingLimit:'',
            rewardIntegralChineseTextLimit:'',
            rewardIntegralEnglishChatVideo:'',
            rewardIntegralEnglishChat:'',
            rewardIntegralEnglishEvaluating:'',
            rewardIntegralChineseText:'',
            drawTutorialVideo:'',
        },
        keyAll:"englishChatEnergy,registerChineseChat,englishChatEnergyPrompt,englishChatEnergyReplace,englishReportEnergy,englishChatLimit,rewardIntegralEnglishChatVideoLimit,rewardIntegralEnglishChatLimit,rewardIntegralEnglishEvaluatingLimit,rewardIntegralChineseTextLimit,rewardIntegralEnglishChatVideo,rewardIntegralEnglishChat,rewardIntegralEnglishEvaluating,rewardIntegralChineseText,englishChatLimitPrompt,englishChatLimitReplace,englishChatLimitRecording,englishChatLimitVoice,registerEnglishChat,drawTutorialVideo",
        pageLoading: false,
        saving: false
    }),
    
    methods: {
        getProfile() {
            request({
                url: "/api/backend/settings/get",
                method: "get",
                params: {
                    key: "version"
                }
            }).then(res => {
                this.form.version = res.data.value || "";  //微信号
                this.pageLoading = false
            });
        },
        getKeyAll() {
            request({
                url: "/api/backend/settings/getAllKey",
                method: "get",
                params: {
                    key: this.keyAll
                }
            }).then(res => {
                this.form.englishChatEnergy = res.data.find(item => item.key ==="englishChatEnergy").value
                this.form.englishChatEnergyPrompt  = res.data.find(item => item.key ==="englishChatEnergyPrompt").value
                this.form.englishChatEnergyReplace = res.data.find(item => item.key ==="englishChatEnergyReplace").value
                this.form.englishReportEnergy = res.data.find(item => item.key ==="englishReportEnergy").value
                this.form.englishChatLimit  = res.data.find(item => item.key ==="englishChatLimit").value
                this.form.englishChatLimitPrompt = res.data.find(item => item.key ==="englishChatLimitPrompt").value
                this.form.englishChatLimitReplace = res.data.find(item => item.key ==="englishChatLimitReplace").value
                this.form.englishChatLimitRecording = res.data.find(item => item.key ==="englishChatLimitRecording").value
                this.form.englishChatLimitVoice  = res.data.find(item => item.key ==="englishChatLimitVoice").value
                this.form.registerEnglishChat  = res.data.find(item => item.key ==="registerEnglishChat").value
                this.form.registerChineseChat  = res.data.find(item => item.key ==="registerChineseChat").value
                this.form.rewardIntegralEnglishChatVideoLimit  = res.data.find(item => item.key ==="rewardIntegralEnglishChatVideoLimit").value
                this.form.rewardIntegralEnglishChatLimit  = res.data.find(item => item.key ==="rewardIntegralEnglishChatLimit").value
                this.form.rewardIntegralEnglishEvaluatingLimit  = res.data.find(item => item.key ==="rewardIntegralEnglishEvaluatingLimit").value
                this.form.rewardIntegralChineseTextLimit  = res.data.find(item => item.key ==="rewardIntegralChineseTextLimit").value
                this.form.rewardIntegralEnglishChatVideo  = res.data.find(item => item.key ==="rewardIntegralEnglishChatVideo").value
                this.form.rewardIntegralEnglishChat  = res.data.find(item => item.key ==="rewardIntegralEnglishChat").value
                this.form.rewardIntegralEnglishEvaluating  = res.data.find(item => item.key ==="rewardIntegralEnglishEvaluating").value
                this.form.rewardIntegralChineseText  = res.data.find(item => item.key ==="rewardIntegralChineseText").value
                this.form.drawTutorialVideo  = res.data.find(item => item.key ==="drawTutorialVideo").value

                this.pageLoading = false
            });
        },

        handleSubmit(formName) {
          this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((result) => {
                  this.onSave(formName)
            })
            .catch((err) => {
              this.$notify.info("已取消");
z            });
        },

        onSave(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.saving = true
                        await request({
                            url: "/api/backend/settings/newStore",
                            method: "post",
                            data: {
                                key:this.form
                            }
                        })
                        this.$message({
                            message: "已保存!",
                            type: 'success'
                        });
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.saving = false
                    }
                    this.getProfile()
                    this.getKeyAll()
                }
            });
        }
    },
    beforeMount() {
        this.getProfile()
        this.getKeyAll()
    }
}
</script>

<style lang="scss" scoped>
.form-box {
    max-width: 900px;
}
</style>